module.exports = __webpack_public_path__ + "static/media/reliable-icon.d0cfc067.svg";